import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import classes from './PersonalForm.module.scss'
import { LOCALE_OPTIONS } from '../../../misc/Constants'
import { updateUserLocale, clearUserLocale } from '../../../actions/userActions'

const LanguageForm = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const currentUser = useSelector(state => state.user.current_user)

  const [locale, setLocale] = useState(currentUser?.locale || '')
  const [isUpdating, setIsUpdating] = useState(false)

  const communityId = currentUser?.communities?.[0]?.id

  const handleSubmit = async e => {
    e.preventDefault()
    setIsUpdating(true)
    try {
      if (locale === '') {
        await dispatch(clearUserLocale(currentUser.id, communityId))
      } else {
        await dispatch(updateUserLocale(currentUser.id, locale, communityId))
      }
    } finally {
      setIsUpdating(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className={classNames(classes.container, 'animated fadeIn')}>
      <div className='row mb-3'>
        <label htmlFor='locale'>{t('common.language')}</label>
        <select
          id='locale'
          name='locale'
          value={locale}
          onChange={e => setLocale(e.target.value)}
          className='form-control'
          style={{ borderRadius: '8px' }}
        >
          <option value=''>{t('account.language.useCommunityDefault')}</option>
          {LOCALE_OPTIONS.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className='row mt-5'>
        <button
          type='submit'
          className='btn btn-primary'
          disabled={isUpdating}
        >
          {t('common.save')}
        </button>
      </div>
    </form>
  )
}

export default LanguageForm
